<div class="page-container">
  <app-card>
    <app-card-content>
      @if (loadingLog()) {
      <div class="loading-message">{{ 'dev.network.loading' | translate }}</div>
      } @else if (activityLog().length === 0) {
      <div class="empty-message">{{ 'dev.network.empty' | translate }}</div>
      } @else {
      <div class="activity-log">
        @for (entry of activityLog(); track entry.timestamp) {
        <div class="log-entry" [attr.data-testid]="'log-entry-' + $index">
          <div class="log-timestamp">
            <div class="timestamp-date">{{ formatDate(entry.timestamp).date }}</div>
            <div class="timestamp-time">{{ formatDate(entry.timestamp).time }}</div>
          </div>
          <span class="log-event">
            @if (entry.newState === 'manual_sync') {
            {{ 'dev.network.manualSync' | translate }}
            } @else {
            {{ entry.newState }}
            }
          </span>
          @if (entry.syncStatus && entry.syncStatus !== 'connected' && entry.syncStatus !== 'disconnected') {
          <span class="log-status" [class.status-failed]="entry.syncStatus === 'failed'">{{ entry.syncStatus }}</span>
          }
        </div>
        }
      </div>
      }
    </app-card-content>
  </app-card>
</div>